import { css } from 'lit-element';
/* @internal */
export const styles = css`:host{--internal-label-min-width: initial;display:block;width:100%}.private-host{width:100%}
`;
